import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-588975dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt", "title"]
const _hoisted_2 = { class: "button-group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { inject } from 'vue';
import { useStore } from 'vuex';
import { Photo } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    photo: {},
    galleryType: {},
    isLogo: { type: Boolean },
    target: {}
  },
  emits: ['rotate', 'delete'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isLogo = props.isLogo || false;

const actProperty: any = inject('actProperty');
const store = useStore();

const emit = __emit

const onRotate = (event: Event) => {
  emit("rotate", props.photo);
};

const onDelete = (event: Event) => {
  emit("delete", props.photo);
};

/**
 * Open a Photo in the Gallery.
 *
 * The Gallery page makes an API call to "get all the Photos in a Report", so
 * any Photos added in the CMS will not be available in the Gallery until the
 * changes to the Report (the new Photos) have been saved to the database.
 */
const openPhotoInGallery = () => {
  if (isLogo) return;
  const reportsState = store.state.reports;
  
  const url = actProperty.photoGalleryUrl(
    props.photo,
    reportsState.current,
    props.galleryType
  );
  window.open(url, "_blank");
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-preview", { logo: _unref(isLogo) }])
  }, [
    _createElementVNode("a", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (openPhotoInGallery()), ["stop"])),
      class: "photo-link"
    }, [
      _createElementVNode("img", {
        src: _unref(actProperty).s3Origin(_ctx.photo.src),
        alt: _unref(actProperty).formatDatetimeForDisplay(_ctx.photo.createdAt),
        title: _unref(actProperty).formatDatetimeForDisplay(_ctx.photo.createdAt),
        class: _normalizeClass({ avatar: _ctx.target === 'inspector' })
      }, null, 10, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-danger",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onDelete()), ["stop"]))
        }, _hoisted_4),
        (!_unref(isLogo))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-sm btn-info rotate-btn-clockwise",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onRotate()), ["stop"]))
            }, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})